const breakpoints = {
  base: "0px",
  xsm: "360px",
  ssm: "400px",
  ssm2: "420px",
  sm: "480px",
  sxm: "576px",
  md: "768px",
  lg: "992px",
  lg2: "1024px",
  lg3: "1140px",
  xl: "1281px",
  xl2: "1440px",
  xxl: "1536px",
  xxxl: "1920px",
}

export default breakpoints
